"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .page_theme_video {
        box-sizing: border-box;
        display: table;
        width: 100%;

        position: relative;
        border: none;
        margin: 0 auto;
        padding: 2em 3em 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        max-width: 80%;
    }
    .page__button {
        height: 3.8em;
        margin-top: 4em;
        text-align: center;
        display: table-row;
    }

    .page__questions {
        display: table-cell;
        height: 100%;
        vertical-align: top;
        position: relative;
    }

    .page__vendor-label {
        display: none;
    }

    .page__button-next,
    .page__button-back {
        margin-top: var(--button-action-margin-top);
        position: relative;
        z-index: 1;

        margin: 0;
        width: 100%;
    }
    .page__button-next::before {
        border-radius: 2px;
    }
    .page__button button::before {
        border: none;
    }

    .page_display-mode_video {
        max-width: 100% !important;
    }
    .page_display-mode_video.page_wide_yes {
        max-width: 80%;
        margin-inline-start: auto;
        margin-inline-end: auto;
    }
    .page_display-mode_video.page_wide_no {
        margin-inline-start: auto;
        margin-inline-end: auto;
    }

    .app_minWidth-400_yes .page_display-mode_video.page_wide_no {
        max-width: 80%;
    }
    .app_minWidth-500_yes .page_display-mode_video.page_wide_no {
        max-width: 75%;
    }
    .app_minWidth-600_yes .page_display-mode_video.page_wide_no {
        max-width: 70%;
    }
    .app_minWidth-700_yes .page_display-mode_video.page_wide_no {
        max-width: 65%;
    }
`;
